import script from "./PassengerLog.vue?vue&type=script&setup=true&lang=ts"
export * from "./PassengerLog.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__